import React, { Fragment } from 'react';
import VoucherCard from '../../images/voucher-card-receipt.png';
import { InstallParagraph, VouchImg } from './CheckCode';
import styled from 'styled-components';

const Wrap = styled.div`
  margin: 16px 24px;
`;

export const FourteenCode = () => (
  <Fragment>
    <VouchImg src={VoucherCard} />
    <Wrap>
      <InstallParagraph>
        Your <b>install code</b> and <b>purchase date</b> can be found on your installation voucher
      </InstallParagraph>
    </Wrap>
  </Fragment>
);
